import { render, staticRenderFns } from "./putGoodsInStock.vue?vue&type=template&id=8e015176&scoped=true"
import script from "./putGoodsInStock.vue?vue&type=script&lang=js"
export * from "./putGoodsInStock.vue?vue&type=script&lang=js"
import style0 from "./putGoodsInStock.vue?vue&type=style&index=0&id=8e015176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e015176",
  null
  
)

export default component.exports